/*
Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.
*/
import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export class Utils {
  static emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const matches = control.value.match(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        );
        return matches ? null : { email: true };
      } else {
        return null;
      }
    };
  }

  static readonly StrongPasswordRegx: RegExp =
    /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d)(?=.*[!@#$%^&*]).{8,}$/;

  static passwordMatchValidator(): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      const g = ctrl as FormGroup;
      return g.get('newPassword')?.value === g.get('confirmPassword')?.value
        ? null
        : { mismatch: true };
    };
  }

  static passwordSimilar(): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      const g = ctrl as FormGroup;
      return g.get('newPassword')?.value !== g.get('currentPassword')?.value
        ? null
        : { similarPswd: true };
    };
  }

  static confirmPasswordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const parent = control.parent as FormGroup;
      if (!parent) {
        return null;
      }
      const newPassword = parent.get('newPassword')?.value;
      if (!newPassword) {
        return null;
      }
      return control.value === newPassword
        ? null
        : { passwordMismatch: true };
    };
  }

  static compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  static isTokenExpiring(tokenExpiration: string, minuteBeforeExpiry: number) {
    // Get the current time
    const currentTime = Date.now();
    const expiration = Date.parse(tokenExpiration);

    // Time until token expiration in milliseconds
    const timeUntilExpiration = expiration - currentTime;
    const timeToUpdate = minuteBeforeExpiry * 60 * 1000;

    if (timeUntilExpiration <= timeToUpdate) {
      return true
    }

    return false;
  }

}
